exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nmain[data-v-50d59de2] {\n    min-height: 70vh;\n    background: #f4f7fa;\n}\n", ""]);

// exports
